import { useEffect } from 'react';

import posthog from 'posthog-js';

import {
  getPostHogKey,
  getPostHogSuperProperties,
  isPostHogEnabled,
  posthogInitOptions,
} from '../../analytics/posthogConfig';
import { useAppSelector } from '../../store/hooks';

/** Initialize PostHog and sync auth to person profiles (identified_only). */
export function PostHogSession() {
  const { user, isAuthenticated } = useAppSelector(state => state.auth);

  useEffect(() => {
    if (!isPostHogEnabled()) {
      return;
    }

    const appProperties = getPostHogSuperProperties();

    if (!posthog.__loaded) {
      posthog.init(getPostHogKey()!, posthogInitOptions);
    }

    posthog.register(appProperties);

    if (isAuthenticated && user) {
      posthog.identify(String(user.id), {
        ...appProperties,
        email: user.email,
        username: user.username,
        name: user.full_name,
        role: user.role,
        district_id: user.district_id,
        school_id: user.school_id,
      });
      return;
    }

    posthog.reset();
    posthog.register(appProperties);
  }, [isAuthenticated, user]);

  return null;
}
